export const REG_EXP_NUMBER = /^-?\d+(\.\d+)?$/;

/** Неотрицательное целое как строка цифр (без знака, без дроби). */
export const REG_EXP_POSITIVE_INTEGER_STRING = /^\d+$/;
